import { Navigate, useRoutes } from "react-router-dom";
import PATHS from "./paths";

import { LoginPage } from "../Templates";
import { Logout, ProtectedRoute } from "./Components";

import { AddModel, Models, Notifications, Profile, Analytics, ViewDrivers, AddDrivers, Lease, Payments, ViewVehicles, VehicleStats, AddVehicle, AddBattery, AddClient, ShowVehicles, ShowBatteries, VehicleDetail, BatteryDetail, Inventory, LeaseVehicles, PastRides, RideDetails, AddGeofence, ViewGeofences, DealersOverview, OrderDetail, OrdersOverview, InventoryOverview, InstallationVideos, ShowDealers, DealershipProfile, EditDealership, TransactionTable, Devices, SpecificDevice, MapToVehicle, ShippingDetails, ShipmentOverview, AllVehicleStats, Alerts, SetOverSpeedAlert, LiveTracking, RedirectToLogin, SetRoutes, ViewRoutes, ViewRouteStats, VehicleActivity, BulkOperationSummary, BulkOperationsHistory, NewBulkOperation, SubUsers, SubUsersInfo, AssignVehsToSubusers, CSLandingPage, SecuredCallRsn, ProfilePage, StickerSettings, ScannedPreviewPage, CsNotifications, EmergencyContact, ActivateContactSticker, CallVehOwner, SharingStopped, ChangePassword, ArchivedRoutes, VehicleRouteSummary, AjjasFeatureIntro, MapDeviceToVehicle, BulkMapDevToVeh, DeviceSubscription, RenewalDetail, UploadRenewalList, DriverManagement, AddDriver, DriverRouteSummary, DriverRouteTrips, DriverFlow, SelectBus, SelectRoute, Navigation, RouteHistory, PlansAndWarranty, PlansAndWarrantyDetail } from "../Pages";
import { Panel, Settings } from "../Templates";
import { AverageRunningReport, BatteryTemperature, BatteryVoltage, ChargeCycle, MotorTemperature, ThrottleReport, MotorStatus, HealthOfBattery } from "../Widgets";
import Tabular from "../Templates/Tabular";
import DriverStats from "../Pages/DriverStats";
import ViewClients from "../Pages/ViewClients";
import { LOGIN_REDIRECT_PATHS } from "../Library/constants";

const AnalyticsRoutes = [
  { path: PATHS.ANALYTICS,  element: <Analytics />, exact: true },
  { path: [PATHS.ANALYTICS, PATHS.MOTOR_TEMPERATURE].join("/"),                                  element: <MotorTemperature />      },
  { path: [PATHS.ANALYTICS, PATHS.MOTOR_TEMPERATURE, PATHS.REPORTS].join("/"),                   element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.MOTOR_STATUS].join("/"),                                       element: <MotorStatus />           },
  { path: [PATHS.ANALYTICS, PATHS.MOTOR_STATUS, PATHS.REPORTS].join("/"),                        element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.AVERAGE_RUNNING].join("/"),                                    element: <AverageRunningReport />  },
  { path: [PATHS.ANALYTICS, PATHS.AVERAGE_RUNNING, PATHS.REPORTS].join("/"),                     element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_TEMPERATURE].join("/"),                                element: <BatteryTemperature />    },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_TEMPERATURE, PATHS.REPORTS].join("/"),                 element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_VOLTAGE].join("/"),                                    element: <BatteryVoltage />        },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_VOLTAGE, PATHS.REPORTS].join("/"),                     element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.CHARGE_CYCLE].join("/"),                                       element: <ChargeCycle />           },
  { path: [PATHS.ANALYTICS, PATHS.CHARGE_CYCLE, PATHS.REPORTS].join("/"),                        element: <Tabular />               },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_HEALTH].join("/"),                                     element: <HealthOfBattery /> },
  { path: [PATHS.ANALYTICS, PATHS.BATTERY_HEALTH, PATHS.REPORTS].join("/"),                      element: <Tabular /> },
  { path: [PATHS.ANALYTICS, PATHS.THROTTLE_PERCENT].join("/"),                                   element: <ThrottleReport />        },
  { path: [PATHS.ANALYTICS, PATHS.THROTTLE_PERCENT, PATHS.REPORTS].join("/"),                    element: <Tabular />               },

  { path: PATHS.INVENTORY,                                                                       element: <Inventory />             },
  { path: PATHS.ADDVEHICLE,                                                                      element: <AddVehicle />            },
  { path: PATHS.ADDBATTERY,                                                                      element: <AddBattery />            },
  { path: PATHS.VEHICLES,                                                                        element: <ShowVehicles />          },
  { path: PATHS.BATTERIES,                                                                       element: <ShowBatteries />         },
  { path: PATHS.BATTERY_DETAIL,                                                                  element: <BatteryDetail />         },
  { path: PATHS.VEHICLE_DETAIL,                                                                  element: <VehicleDetail />         },
  { path: PATHS.ADDMODEL,                                                                        element: <AddModel />              },
];

const LeaseRoutes = [
  { path: PATHS.LEASE,                                                                           element: <Lease />,    exact: true },
  { path: PATHS.LEASE_VEHICLES,                                                                  element: <LeaseVehicles />         },
  { path: PATHS.LEASED_VEHICLES,                                                                 element: <ViewVehicles />          },
  { path: [PATHS.LEASED_VEHICLES, PATHS.VEHICLE_STATS].join("/"),                                element: <VehicleStats />          },
  { path: [PATHS.LEASE, PATHS.DRIVERS].join("/"),                                                element: <ViewDrivers />           },
  { path: [PATHS.LEASE, PATHS.ADD_DRIVERS].join("/"),                                            element: <AddDrivers />            },
  { path: [PATHS.LEASE, PATHS.DRIVERS, PATHS.DRIVER_STATS].join("/"),                            element: <DriverStats />           },
  { path: [PATHS.LEASE, PATHS.PAYMENTS].join("/"),                                               element: <Payments />              },
  { path: [PATHS.LEASED_VEHICLES, PATHS.PAST_RIDES].join("/") + "/:vId",                         element: <PastRides />             },
  { path: [PATHS.LEASED_VEHICLES, PATHS.PAST_RIDES, PATHS.RIDE_DETAILS].join("/"),               element: <RideDetails />           },

  { path: PATHS.ADD_GEOFENCE,                                                                    element: <AddGeofence />           },
  { path: PATHS.VIEW_GEOFENCES,                                                                  element: <ViewGeofences />         },
];

const ACC_101 = [
  { path: PATHS.DEALERS_OVERVIEW,                                                                element: <DealersOverview />       },
  { path: [PATHS.DEALERS_OVERVIEW, PATHS.TRANSACTION_DETAILS].join("/"),                         element: <TransactionTable />      },
  { path: [PATHS.DEALERS_OVERVIEW, PATHS.ORDERS_OVERVIEW].join(""),                              element: <OrdersOverview />        },
  { path: [PATHS.DEALERS_OVERVIEW, PATHS.ORDERS_OVERVIEW, `/${PATHS.ORDER_DETAIL}`].join(""),    element: <OrderDetail />           },
];

const ACC_201 = [
  { path: PATHS.SHOW_DEALERS,                                                                    element:<ShowDealers />            },
  { path: PATHS.ADD_DEALER,                                                                      element:<AddClient />              },
  { path: [PATHS.SHOW_DEALERS, PATHS.SPECIFIC_DEALER].join("/"),                                 element:<DealershipProfile />      },
  { path: [PATHS.SHOW_DEALERS, PATHS.EDIT_DEALER].join("/"),                                     element:<EditDealership />         },
  { path: [PATHS.SHOW_DEALERS, PATHS.DEVICES].join("/"),                                         element:<Devices />                },
  { path: [PATHS.SHOW_DEALERS, PATHS.SPECIFIC_DEVICE].join("/"),                                 element:<SpecificDevice />         },
  { path: [PATHS.SHOW_DEALERS, PATHS.SPECIFIC_DEVICE, PATHS.EDIT_VEHICLE_DETAILS].join("/"),     element:<MapToVehicle />           },
];

const ACC_301 = [
  { path: PATHS.INVENTORY_OVERVIEW,                                                              element: <InventoryOverview />     },
  { path: [PATHS.INVENTORY_OVERVIEW, PATHS.DEVICES].join("/"),                                   element:<Devices />                },
  { path: [PATHS.INVENTORY_OVERVIEW, PATHS.SPECIFIC_DEVICE].join("/"),                           element:<SpecificDevice />         },
  { path: [PATHS.INVENTORY_OVERVIEW, PATHS.MAP_TO_VEHICLE].join("/"),                            element:<MapToVehicle />           },
]

const ACC_401 = [
  { path: PATHS.SHIPMENT_OVERVIEW,                                                               element: <ShipmentOverview />      },
  { path: PATHS.ORDERS_OVERVIEW,                                                                 element: <OrdersOverview />        },
  { path: [PATHS.ORDERS_OVERVIEW, PATHS.TRANSACTION_DETAILS].join("/"),                          element: <TransactionTable />      },
  { path: [PATHS.ORDERS_OVERVIEW, `/${PATHS.ORDER_DETAIL}`].join(""),                            element: <OrderDetail />           },
  { path: [PATHS.ORDERS_OVERVIEW, PATHS.ORDER_DETAIL].join("/"),                                 element: <OrderDetail />           },
  { path: [PATHS.SHOW_DEALERS,PATHS.OEM_DEALERS].join("/"),                                      element: <ShowDealers />           },
  { path: [PATHS.SHIPMENT_OVERVIEW, PATHS.SHIPPING_DETAILS].join("/"),                           element: <ShippingDetails />       },
  { path: [PATHS.SHIPMENT_OVERVIEW, PATHS.ORDER_DETAIL].join("/"),                               element: <OrderDetail />           },
]

const ACC_501 = [
  { path: PATHS.INSTALLATION_VIDEO,                                                              element: <InstallationVideos />    },
]

const ACC_601 = [
  { path: [PATHS.SHIPMENT_OVERVIEW, PATHS.SHIPPING_DETAILS].join("/"),                           element: <ShippingDetails />       },
  { path: [PATHS.SHIPMENT_OVERVIEW, PATHS.ORDER_DETAIL].join("/"),                               element: <OrderDetail />           },
  { path: PATHS.SHIPMENT_OVERVIEW,                                                               element: <ShipmentOverview />      },
  { path: [PATHS.SHIPMENT_OVERVIEW, PATHS.ORDERS_OVERVIEW, `/${PATHS.ORDER_DETAIL}`].join(""),   element: <OrderDetail />           },
]

const ACC_701 = [
  { path: PATHS.LIVE_TRACKING,                                                                   element: <LiveTracking />          },
  { path: [PATHS.LIVE_TRACKING, PATHS.MAP_DEVICE].join("/"),                                     element: <MapDeviceToVehicle />    },
  { path: [PATHS.LIVE_TRACKING, PATHS.BULK_MAP_DEVICE].join("/"),                                element: <BulkMapDevToVeh />    },
  { path: [PATHS.LIVE_TRACKING, PATHS.VEHICLE_STATS].join("/"),                                  element: <VehicleStats />          },
  { path: [PATHS.LIVE_TRACKING, PATHS.VEHICLE_STATS, PATHS.UPDATE_VEHICLE].join("/"),            element: <AddVehicle />            },
  { path: [PATHS.LIVE_TRACKING, PATHS.PAST_RIDES].join("/") + "/:vId",                           element: <PastRides />             },
  { path: [PATHS.LIVE_TRACKING, PATHS.PAST_RIDES, PATHS.RIDE_DETAILS].join("/"),                 element: <RideDetails />           },
  { path: [PATHS.LIVE_TRACKING, PATHS.ALL_VEHICLE_STATS].join(""),                               element: <VehicleStats/>           },

  { path: [PATHS.LIVE_TRACKING, PATHS.SPECIFIC_DEVICE].join("/"),                                element:<SpecificDevice />         },
  { path: [PATHS.LIVE_TRACKING, PATHS.SINGLE_VEHICLE_STATS].join("/"),                           element:<VehicleStats/>            },
  { path: [PATHS.LIVE_TRACKING, PATHS.EDIT_DEALER].join("/"),                                    element:<EditDealership />         },
  { path: [PATHS.LIVE_TRACKING, PATHS.SPECIFIC_DEVICE, PATHS.EDIT_VEHICLE_DETAILS].join("/"),    element:<MapToVehicle />           },
]

const ACC_801 = [
  { path: PATHS.ALL_VEHICLE_STATS,                                                               element: <AllVehicleStats/>        },
  { path: [PATHS.ALL_VEHICLE_STATS, PATHS.SINGLE_VEHICLE_STATS].join("/"),                       element: <VehicleStats/>           },
]

const ACC_901 = [
  { path: PATHS.SET_ALERTS,                                                                      element: <Alerts />                },
  { path: [PATHS.SET_ALERTS, PATHS.ADD_GEOFENCE_ALERT].join("/"),                                element: <AddGeofence />           },
  { path: [PATHS.SET_ALERTS, PATHS.ADD_OVERSPEED_ALERT].join("/"),                               element: <SetOverSpeedAlert />     },
]

const ACC_1101 = [
  { path: PATHS.VEHICLE_ACTIVITY,                                                                element: <VehicleActivity />       },
]

const ACC_1201 = [
  { path: PATHS.VIEW_ROUTES,                                                                     element: <ViewRoutes />            },
  { path: [PATHS.VIEW_ROUTES, PATHS.SET_ROUTES].join(""),                                        element: <SetRoutes />             },
  { path: [PATHS.VIEW_ROUTES, PATHS.ARCHIVED_ROUTES].join(""),                                   element: <ArchivedRoutes />        },
  { path: [PATHS.VIEW_ROUTES, PATHS.VIEW_STATS].join("/"),                                       element: <ViewRouteStats />        },
  { path: [PATHS.VIEW_ROUTES, PATHS.ROUTES_SUMMARY].join(""),                                    element: <VehicleRouteSummary />   },
  { path: [PATHS.VIEW_ROUTES, PATHS.PAST_RIDES].join("/") + "/:vId",                             element: <PastRides />             },
  { path: [PATHS.VIEW_ROUTES, PATHS.PAST_RIDES, PATHS.RIDE_DETAILS].join("/"),                   element: <RideDetails />           },
];

const ACC_1301 = [
  { path: PATHS.BULK_OPERATIONS,                                                                 element: <BulkOperationsHistory /> },
  { path: [PATHS.BULK_OPERATIONS, PATHS.NEW_BULK_OPERATION].join(""),                            element: <NewBulkOperation />      },
  { path: [PATHS.BULK_OPERATIONS, PATHS.OPERATION_SUMMARY].join(""),                             element: <BulkOperationSummary />  },
];

const ACC_1401 = [
  { path: PATHS.SUB_USERS,                                                                       element: <SubUsers />              },
  { path: [PATHS.SUB_USERS, PATHS.CREATE_SUB_USER].join("/"),                                    element: <AddClient />             },
  { path: [PATHS.SUB_USERS, PATHS.SUB_USER_DETS].join("/"),                                      element: <SubUsersInfo />          },
  { path: [PATHS.SUB_USERS, PATHS.SUB_USER_DETS, PATHS.ASSIGN_VEHICLES].join("/"),               element: <AssignVehsToSubusers />  },
];

const ACC_1501 = [
  { path: PATHS.NOTIFICATIONS,                                                                   element: <Notifications />         },
];

const ACC_1601 = [
  { path: PATHS.DEVICE_SUBSCRIPTION, element: <DeviceSubscription /> },
  { path: [PATHS.DEVICE_SUBSCRIPTION, PATHS.RENEWAL_DETAIL].join(""), element: <RenewalDetail /> },
  { path: [PATHS.DEVICE_SUBSCRIPTION, PATHS.UPLOAD_RENEWAL_LIST].join(""), element: <UploadRenewalList /> },
];

const ACC_1701 = [
  { path: PATHS.DRIVER_MANAGEMENT, element: <DriverManagement /> },
  { path: [PATHS.DRIVER_MANAGEMENT, PATHS.DRIVER_MANAGEMENT_ADD].join("/"), element: <AddDriver /> },
  { path: [PATHS.DRIVER_MANAGEMENT, PATHS.DRIVER_SUMMARY].join("/"), element: <DriverRouteSummary /> },
  { path: [PATHS.DRIVER_MANAGEMENT, PATHS.DRIVER_TRIPS].join("/"), element: <DriverRouteTrips /> },
  { path: [PATHS.DRIVER_MANAGEMENT, PATHS.DRIVER_RIDE_DETAILS].join("/"), element: <RideDetails /> },
];

const ACC_1801 = [
  {
    path: PATHS.DRIVER_ROUTE_CHECK,
    element: <DriverFlow />,
    children: [
        { path: PATHS.SELECT_BUS, element: <SelectBus /> },
        { path: PATHS.SELECT_ROUTE, element: <SelectRoute /> },
        { path: PATHS.NAVIGATION, element: <Navigation /> },
    ]
  },
];

const ACC_1901 = [
  { path: PATHS.ROUTE_HISTORY, element: <RouteHistory /> },
  { path: [PATHS.ROUTE_HISTORY, PATHS.PAST_RIDES, PATHS.RIDE_DETAILS].join("/"), element: <RideDetails /> },
];

const ACC_2001 = [
  { path: PATHS.PLANS_AND_WARRANTY,                                                                element: <PlansAndWarranty />      },
  { path: [PATHS.PLANS_AND_WARRANTY, PATHS.PLANS_AND_WARRANTY_DETAIL].join("/"),                   element: <PlansAndWarrantyDetail />},
];

const ACCESS_CODE_ROUTES = {
  "ACC_101": ACC_101,
  "ACC_201": ACC_201,
  "ACC_301": ACC_301,
  "ACC_401": ACC_401,
  "ACC_501": ACC_501,
  "ACC_601": ACC_601,
  "ACC_701": ACC_701,
  "ACC_801": ACC_801,
  "ACC_901": ACC_901,
  "ACC_1001": AnalyticsRoutes,
  "ACC_1101": ACC_1101,
  "ACC_1201": ACC_1201,
  "ACC_1301": ACC_1301,
  "ACC_1401": ACC_1401,
  "ACC_1501": ACC_1501,
  "ACC_1601": ACC_1601,
  "ACC_1701": ACC_1701,
  "ACC_1801": ACC_1801,
  "ACC_1901": ACC_1901,
  "ACC_2001": ACC_2001,
};



const CS_ROUTES = [
  { path: [PATHS.CONTACT_STICKER, PATHS.CS_ACT_PAGE].join("/"), element: <ActivateContactSticker /> },
  { path: [PATHS.CONTACT_STICKER, PATHS.CALL_OWNER].join("/"), element: <CallVehOwner /> },
  { path: [PATHS.CONTACT_STICKER, PATHS.SHARING_STOPED].join("/"), element: <SharingStopped /> },
  { path: [ PATHS.CONTACT_STICKER, PATHS.LANDING_PAGE ].join(""), element: <CSLandingPage /> },
  { path: [ PATHS.CONTACT_STICKER, PATHS.SECURED_CALL_RSN ].join(""), element: <SecuredCallRsn /> },
  { path: [ PATHS.CONTACT_STICKER, PATHS.PROFILE_PAGE ].join(""), element: <ProfilePage /> },
  { path: [ PATHS.CONTACT_STICKER, PATHS.STICKER_SETTINGS ].join(""), element: <StickerSettings /> },
  { path: [ PATHS.SCANNED_PREVIEW_PAGE ].join(""), element: <ScannedPreviewPage /> },
  { path: [ PATHS.CONTACT_STICKER, PATHS.CS_NOTIFICATIONS ].join(""), element: <CsNotifications /> },
  { path: [ PATHS.CONTACT_STICKER, PATHS.EMERGENCY_CONTACT ].join(""), element: <EmergencyContact /> },
]

const FEATURE_AWARENESS_ROUTE = { path: PATHS.FEATURE_AWARENESS, element: <AjjasFeatureIntro /> };

const AppRoutes = ({ codes, user }) => {
  let routesArray = [];
  let baseRoutes = [];
  let settingsRoutes = [];
  let hasAccessCodes = codes && codes.length;

  if (hasAccessCodes) {
    codes.forEach(code => {
      if (ACCESS_CODE_ROUTES[`ACC_${code}`]) routesArray = routesArray.concat(ACCESS_CODE_ROUTES[`ACC_${code}`]);
    });
  } else routesArray.concat([ ...AnalyticsRoutes, ...LeaseRoutes ]);

  settingsRoutes = [{ path: PATHS.PROFILE, element: <Profile /> }, { path: PATHS.CHANGE_PASSWORD, element: <ChangePassword /> }];
  if (!hasAccessCodes) {
    settingsRoutes.concat([{ path: PATHS.MODELS, element: <Models /> }, { path: PATHS.CLIENTS, element: <ViewClients /> }]);
  }

  baseRoutes = [
    {
      element: <ProtectedRoute />,
      children: [
        { path: "/", index: true, exact: true, element: <Navigate to={hasAccessCodes ? LOGIN_REDIRECT_PATHS[codes[0]] : PATHS.ANALYTICS} /> },
        { path: PATHS.LOGOUT, element: <Logout />, },
        { path: "/", element: <Panel user={user} codes={codes} />, children: [
            ...routesArray,
            { path: PATHS.SETTINGS, element: <Settings />, children: settingsRoutes },
          ]
        },
        ...CS_ROUTES,
        FEATURE_AWARENESS_ROUTE,
        { path: "*", element: <RedirectToLogin />, },
      ],
    }
  ];

  const element = useRoutes(baseRoutes);

  return element;
};

export default AppRoutes;


export const UnauthorizedRoutes = () => {
  const element = useRoutes([
    { path: PATHS.LOGIN, element: <ProtectedRoute noLogin> <LoginPage /> </ProtectedRoute> },
    ...CS_ROUTES,
    FEATURE_AWARENESS_ROUTE,
    { path: "/", element: <Navigate to={PATHS.LOGIN} /> },
    { path: "*", element: <RedirectToLogin />, },
  ]);

  return element;
};
